(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/redux/store.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/redux/store.js');

'use strict';

const svsconfig = svs.core.config.data.svsconfig;
const {
  configureStore
} = RTK;
const {
  containers
} = svs.numbergames.fractiongames.redux.slices;
const {
  socketMiddleware,
  containersMiddleware
} = svs.numbergames.fractiongames.redux.middlewares;
const store = configureStore({
  reducer: containers.reducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(socketMiddleware, containersMiddleware),
  devTools: svsconfig.env !== 'production'
});
svs.numbergames.fractiongames.redux.store = store;

 })(window);